import cx from 'classnames';
import { forwardRef, type ReactElement, type Ref } from 'react';

import { RouterLink, type RouterLinkProps } from '@trello/router/router-link';

import * as styles from './IconListTile.module.less';

interface IconListTileProps extends RouterLinkProps {
  icon: ReactElement;
}

export const IconListTile = forwardRef(
  (
    { icon, className, href, testId, children, ...props }: IconListTileProps,
    ref: Ref<HTMLAnchorElement>,
  ) => (
    <RouterLink
      className={cx(styles.tile, className)}
      href={href}
      testId={testId}
      ref={ref}
      {...props}
    >
      <div className={styles.details}>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.title}>{children}</div>
      </div>
    </RouterLink>
  ),
);
